<template>
  <component :is="currentHomeComponent" />
</template>

<script>
import Vue from "vue";
import { computed } from 'vue';
import { useStore } from 'vuex';
import store from "@utils/store/cookie";
export default {
  setup() {
    //const userInfo = localStorage.getItem('userInfo'); 
	// if (userInfo) {
   // const user = JSON.parse(userInfo);
 
  // console.log(user);
   //	const qx = user.qx;
	  
  //}
  	//const user=Vue.prototype.$user;
	//const qx =  store.get("qx") || null;
 const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
 
    const currentHomeComponent = computed(() => {
      switch (user.qx) {
        case '15': return () => import('@views/huizong/Huizong');
        case '4': return () => import('@components/goods/goods');
		 case '1': return () => import('@views/caigou/Caigou');
        default: return () => import('@components/goods/goods');
      }
    });
    return { currentHomeComponent };
  }
};
</script>